const config = {
  ENVIRONMENT_NAME: 'prod',
  forwoodId: {
    URL: 'https://id.europe.forwoodsafety.com',
    USER_TOKEN_URL: 'https://jgfj4lx09i.execute-api.eu-west-1.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'eu-west-1',
    URL: 'https://lavx0kxk53.execute-api.eu-west-1.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'teams-container-1.11.7',
    HOSTNAME: 'https://teams.europe.forwoodsafety.com',
    TEAMS_MICROFRONTEND_URL: 'https://teams-service.europe.forwoodsafety.com',
    TARGETS_MICROFRONTEND_URL: 'https://targets.europe.forwoodsafety.com',
    TEAMS_ACCESS_ROLE: 'TeamsAccess',
    TEAM_TARGETS_ACCESS_ROLE: 'TeamTargetsAccess',
  },
  configurationService: {
    URL: 'https://config.europe.forwoodsafety.com',
    WEBSOCKET: 'wss://a1l7hepeqj.execute-api.eu-west-1.amazonaws.com/prod'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
